import React from "react";

function NoPage() {
    return (
        <h1>Page doesn't exist.</h1>
    );
}

export default NoPage;
